import { useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icBusinessPurpose from './assets/img/ic-briefcase.svg';
import icLocalActivities from './assets/img/ic-city-buildings.svg';
import icLocalStaffing from './assets/img/ic-user-square.svg';

const CompanyAddBusinessType = ({ formData, handleChange, handleBusinessSubmit, isEditPage }) => { // ✅ Ensure correct function name

    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values
    
    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };
    
    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleBusinessSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleBusinessSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleBusinessSubmit is not a function.');
        }
    };
    
    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <>
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">5.</span>Business Type</h3>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        {isEditing ? (
                            <>
                                <Row className="mb-3">
                                    <Col md={6}> 
                                        {/* Business Purpose */}
                                        <Form.Group controlId="businessPurpose">
                                            <Form.Label>Business Purpose</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="businessPurpose"
                                                value={formData.businessPurpose || ''}
                                                onChange={handleChange}
                                                disabled={!isEditing}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}> 
                                        {/* Local Activities */}
                                        <Form.Group controlId="localActivities">
                                            <Form.Label>Local Activities</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="localActivities"
                                                value={formData.localActivities || ''}
                                                onChange={handleChange}
                                                disabled={!isEditing}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}> 
                                        {/* Local Staffing Details */}
                                        <Form.Group controlId="localStaffing">
                                            <Form.Label>Local Staffing Details</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="localStaffing"
                                                value={formData.localStaffing || ''} // ✅ Ensure fallback value
                                                onChange={handleChange}
                                                disabled={!isEditing} // ✅ Disable when not editing
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}> 
                                        {/* Other */}
                                        <Form.Group controlId="businessTypeOther">
                                            <Form.Label>Other</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="businessTypeOther"
                                                value={formData.businessTypeOther || ''} // ✅ Ensure fallback value
                                                onChange={handleChange}
                                                disabled={!isEditing} // ✅ Disable when not editing
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        ): (
                            // Not editing
                            <>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icBusinessPurpose} alt="Business Purpose" />
                                            </span>
                                            <span className="text">
                                                Business Purpose:
                                                <br />
                                                <strong>
                                                    {formData.businessPurpose || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icLocalActivities} alt="Local Activities" />
                                            </span>
                                            <span className="text">
                                                Local Activities:
                                                <br />
                                                <strong>
                                                    {formData.localActivities || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icLocalStaffing} alt="Local staffing details" />
                                            </span>
                                            <span className="text">
                                                Local staffing details:
                                                <br />
                                                <strong>
                                                    {formData.localStaffing || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="icon-text">
                                            <span className="icon" aria-hidden="true">
                                                <Image src={icBusinessPurpose} alt="Other" />
                                            </span>
                                            <span className="text">
                                                Other:
                                                <br />
                                                <strong>
                                                    {formData.businessTypeOther || "N/A"}
                                                </strong>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>
                    
                </Card.Body>
            </Card>
        </>
    );
};

export default CompanyAddBusinessType;
